import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

export const SiteContext = createContext();

export const SiteProvider = ({ children }) => {
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/options`)
      .then(({ data }) => {
        setOptions(data);
        setLoading(false);

        // Set favicon
        if (data.favicon_url) {
          const existing = document.querySelector("link[rel~='icon']");
          if (existing) {
            existing.href = data.favicon_url;
          } else {
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = data.favicon_url;
            document.head.appendChild(link);
          }
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <SiteContext.Provider value={{ options, loading }}>
      {children}
    </SiteContext.Provider>
  );
};
